import { j as r } from "../../../../_virtual/jsx-runtime.js";
import { useState as Z } from "react";
import { ChartContainer as X } from "../../../ui/chart.js";
import { COMMON_COLORS as q } from "../../../../constants/colors.js";
import J from "./SleepStages.js";
import R from "./YAxisTopLabel.js";
import { REFERENCE_LINE_ORIENTATION as j } from "./types.js";
import Q from "../AlertMarker/index.js";
import S from "../TooltipWrapper/index.js";
import { ResponsiveContainer as U } from "../../../../node_modules/recharts/es6/component/ResponsiveContainer.js";
import { ComposedChart as L } from "../../../../node_modules/recharts/es6/chart/ComposedChart.js";
import { CartesianGrid as K } from "../../../../node_modules/recharts/es6/cartesian/CartesianGrid.js";
import { XAxis as oo } from "../../../../node_modules/recharts/es6/cartesian/XAxis.js";
import { YAxis as y } from "../../../../node_modules/recharts/es6/cartesian/YAxis.js";
import { ReferenceLine as to } from "../../../../node_modules/recharts/es6/cartesian/ReferenceLine.js";
import { Line as ro } from "../../../../node_modules/recharts/es6/cartesian/Line.js";
import { Bar as ao } from "../../../../node_modules/recharts/es6/cartesian/Bar.js";
import { Tooltip as so } from "../../../../node_modules/recharts/es6/component/Tooltip.js";
const Co = ({
  data: N,
  config: s,
  xAxis: n,
  leftAxis: l,
  rightAxis: i,
  referenceLines: c,
  trendLines: d,
  onChartClick: E,
  onLineClick: p,
  onLineMouseEnter: u,
  onLineMouseLeave: f,
  onAlertClick: h,
  bars: x,
  tooltipWrapperClassName: A,
  tooltipBgColor: T,
  alertTooltipWrapperClassName: $,
  alertTooltipBgColor: g,
  renderTooltip: D,
  renderAlertTooltip: b,
  hideTooltip: w,
  children: z
}) => {
  const [k, v] = Z(null), I = Object.keys(s).includes("sleep") || Object.keys(s).includes("rem"), M = (o, a, t) => {
    t.stopPropagation(), t.preventDefault(), p == null || p(o, a, t);
  }, B = (o, a, t) => {
    t.stopPropagation(), t.preventDefault(), u == null || u(o, a, t);
  }, F = (o, a, t) => {
    t.stopPropagation(), t.preventDefault(), f == null || f(o, a, t);
  }, G = (o) => {
    b && v(o);
  }, H = () => {
    v(null);
  }, P = (o) => k && b ? /* @__PURE__ */ r.jsx(
    S,
    {
      className: $,
      bgColor: g,
      children: b(k, o.payload || [], s)
    }
  ) : w ? null : /* @__PURE__ */ r.jsx(
    S,
    {
      className: A,
      bgColor: T,
      children: D(o.payload || [], s)
    }
  );
  return /* @__PURE__ */ r.jsxs("div", { className: "relative m-0 p-0", children: [
    /* @__PURE__ */ r.jsx(X, { config: s, className: "trends-chart w-full pb-5 m-0", children: /* @__PURE__ */ r.jsx(U, { width: "100%", height: "100%", className: "m-0 p-0", children: /* @__PURE__ */ r.jsxs(
      L,
      {
        data: N,
        margin: { top: 40, right: 0, left: 0, bottom: 20 },
        barGap: 0,
        barCategoryGap: 0,
        onClick: E,
        children: [
          /* @__PURE__ */ r.jsx(K, { stroke: q.greyLight }),
          /* @__PURE__ */ r.jsx(
            oo,
            {
              axisLine: !1,
              dataKey: n.dataKey,
              tickLine: !1,
              dx: 0,
              dy: I ? 30 : 10,
              padding: { left: 0, right: 0 },
              height: 50,
              orientation: "bottom",
              tickFormatter: n.tickFormatter,
              ticks: n.ticks
            }
          ),
          /* @__PURE__ */ r.jsx(
            y,
            {
              stroke: "#888888",
              fontSize: 12,
              tickLine: !1,
              axisLine: !1,
              yAxisId: l.yAxisId,
              domain: l.domain,
              label: {
                value: l.label,
                content: ({ viewBox: o }) => /* @__PURE__ */ r.jsx(
                  R,
                  {
                    label: l.label,
                    icon: l.labelIcon,
                    position: "left",
                    viewBox: o
                  }
                )
              }
            }
          ),
          /* @__PURE__ */ r.jsx(
            y,
            {
              stroke: "#888888",
              fontSize: 12,
              tickLine: !1,
              axisLine: !1,
              yAxisId: i.yAxisId,
              orientation: "right",
              domain: i.domain,
              label: {
                value: i.label,
                content: ({ viewBox: o }) => /* @__PURE__ */ r.jsx(
                  R,
                  {
                    label: i.label,
                    icon: i.labelIcon,
                    position: "right",
                    viewBox: o
                  }
                )
              }
            }
          ),
          c == null ? void 0 : c.map(({ dataKey: o, value: a, yAxisId: t, orientation: e }) => {
            var m;
            return /* @__PURE__ */ r.jsx(
              to,
              {
                x: e === j.VERTICAL ? a : void 0,
                y: e === j.HORIZONTAL ? a : void 0,
                yAxisId: t,
                stroke: (m = s[o]) == null ? void 0 : m.color,
                strokeDasharray: e === j.HORIZONTAL ? "3 4" : void 0,
                strokeWidth: "2"
              },
              `${o}-${a}`
            );
          }),
          d == null ? void 0 : d.map(({ dataKey: o, yAxisId: a, hide: t }) => {
            var m;
            const e = (m = s[o]) == null ? void 0 : m.color;
            return /* @__PURE__ */ r.jsx(
              ro,
              {
                className: p ? "cursor-pointer" : "",
                yAxisId: a,
                type: "monotone",
                dataKey: o,
                stroke: e,
                strokeWidth: 2,
                isAnimationActive: !1,
                onClick: M.bind(void 0, o),
                onMouseEnter: B.bind(void 0, o),
                onMouseLeave: F.bind(void 0, o),
                dot: (W) => {
                  const { cx: _, cy: V, key: Y, payload: O } = W, C = {
                    dataKey: `${o}Alert`,
                    value: O[`${o}Alert`]
                  };
                  return O[`${o}Alert`] ? /* @__PURE__ */ r.jsx(
                    Q,
                    {
                      color: e,
                      cx: _,
                      cy: V,
                      onClick: h == null ? void 0 : h.bind(void 0, C),
                      onMouseEnter: G.bind(
                        void 0,
                        C
                      ),
                      onMouseLeave: H
                    },
                    `${o}-${Y}`
                  ) : null;
                },
                activeDot: !1,
                connectNulls: !1,
                hide: t
              },
              o
            );
          }),
          x == null ? void 0 : x.map(({ dataKey: o, yAxisId: a }) => {
            var t;
            return /* @__PURE__ */ r.jsx(
              ao,
              {
                yAxisId: a,
                dataKey: o,
                fill: (t = s[o]) == null ? void 0 : t.color,
                barSize: 12,
                maxBarSize: 12,
                radius: [10, 10, 0, 0]
              },
              o
            );
          }),
          /* @__PURE__ */ r.jsx(
            so,
            {
              content: P,
              allowEscapeViewBox: { x: !0, y: !0 },
              offset: 0,
              isAnimationActive: !1,
              cursor: !0,
              includeHidden: !0
            }
          ),
          z
        ]
      }
    ) }) }),
    I && /* @__PURE__ */ r.jsx(
      J,
      {
        className: "bottom-16",
        data: N
      }
    )
  ] });
};
export {
  Co as default
};
